import { Injectable } from '@angular/core';
import { PaymentProvider } from './interfaces/payment-provider';
import { DwspayService } from './dwspay.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private currentProvider: PaymentProvider | undefined;

  constructor(private dwspayService: DwspayService) {}

  async setPaymentMethod(method: 'dwspay') {
    switch (method) {
      case 'dwspay':
        await this.dwspayService.initializePayment();
        this.currentProvider = this.dwspayService;
        break;
      default:
        throw new Error('Metodo di pagamento non supportato');
    }
  }

  createPaymentElement() {
    return this.currentProvider?.createPaymentElement();
  }

  async processPayment(clientSecret: string, amount: number, cardElement: any) {
    if (!this.currentProvider) {
      throw new Error('Payment provider is not set');
    }
    return this.currentProvider.processPayment(clientSecret, amount, cardElement);
  }
}
